// extracted by mini-css-extract-plugin
module.exports = {"notice":"StepHeader_notice__MJsvB","popup":"StepHeader_popup__6Q_jA","menu":"StepHeader_menu__YMcdg","fadeIn":"StepHeader_fadeIn__JYI7e","spin":"StepHeader_spin__xSl0U"};